import BaseView from "./_BaseView";
import Table from "../components/Table";

export default class ProductView extends BaseView {

    init() {
        super.init();

        const container = $('#jumpsTable');
        if (container.length > 0) {
            const datepicker = $('#jumpsTable input[name="daterange"]');
            flatpickr('#jumpsTable input[name="daterange"]', {
                mode: 'range'
            });

            const start = new Date(Date.now() - 2592000000),
                end = new Date();
            const startDate = start.toISOString().slice(0, 10),
                endDate = end.toISOString().slice(0, 10);
            datepicker.val(`${startDate} to ${endDate}`).trigger('change');

            container.find('.reset').on('click', function () {
                datepicker.val(`${startDate} to ${endDate}`).trigger('change');
                return false;
            });

            this.table = new Table('jumpsTable', '/api/product/jumps', [
                {data: 'organization', orderable: true},
                {data: 'application'},
                {data: 'url'},
                {data: 'guideTakers'},
                {data: 'guidesStarted'},
                {data: 'guidesCompleted'},
                {data: 'tools', orderable: false},
            ]);
        }
    }
}
